import { render, staticRenderFns } from "./DialogBatchNote.vue?vue&type=template&id=152be81c"
import script from "./DialogBatchNote.vue?vue&type=script&lang=js"
export * from "./DialogBatchNote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports